import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const LogoWrapper = styled(Link)`
display: flex;
align-items: center;
text-decoration: none;
cursor: pointer;

@media (max-width: 1377px) {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 12px;
}
`;

const LogoText = styled.h2`
    font-size: 20px;
    margin: 0;
    margin-left: 4px;
    font-weight: var(--font-weight-extrabold);
    color: #ff1493;
    letter-spacing: -0.02em;
`;

export function Logo() {
    return <LogoWrapper to="/">
        <LogoText>Song Carousel</LogoText>
    </LogoWrapper>


}